var twig = require("twig").twig,
    tokens = [],
    template = twig({"id":"$resolved:fc02b17f191883d7303228a352f3182720eb8d1b4d02c47106aaab362cdbf0066aad5c40c7bbae5fac984209cbc3c00fd0704cbd841b86f7007d3c52e2a1d16b:zengular-notification.twig","data":[],"allowInlineIncludes":true,"rethrow":true});

module.exports = function(context) { return template.render(context); }

module.exports.tokens = tokens;